import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-tech bg-white py-5 sm:py-7" data-id="element-40" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-41" data-mp="844a752d8tdr">
        <h2 className="text-center text-3xl leading-none text-navy sm:text-5xl" data-id="element-42" data-mp="m4ylpwkpnagn">
          ONE LAST <span className="text-tech" data-id="element-43" data-mp="m2lt8phbthpc">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-steel sm:text-base" data-id="element-44" data-mp="h52dtm8w6yvt">
          <p data-id="element-45" data-mp="vtypdta5qu16">
            When you're identifying weld discontinuities, measuring weld geometry, interpreting
            NDT indications, reviewing quality requirements, or preparing inspection
            documentation...
          </p>
          <p data-id="element-46" data-mp="zwmx1xn4xuwk">
            Do you have one organized visual reference system that helps you recognize the
            indications, understand the methods, and document what you're inspecting?
          </p>
          <p data-id="element-47" data-mp="2h37vmsm9yawg">
            Stop relying entirely on scattered diagrams, disconnected technical explanations, and
            endless searches for welding inspection references.
          </p>
          <p data-id="element-48" data-mp="2r1nqn6ofa4b8">
            <strong className="font-semibold text-navy" data-id="element-49" data-mp="2r2786ma5uqoq">
              See the discontinuities. Understand the methods. Organize the findings. Inspect with
              greater clarity.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-50" data-mp="30111a2oa8yxj" />

        <div className="mt-2 text-center" data-id="element-51" data-mp="34tc35b2l2usq">
          <p className="font-heading text-2xl uppercase leading-none text-navy sm:text-4xl" data-id="element-52" data-mp="34un3t20qfmfm">
            🔍 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-bold uppercase leading-tight tracking-wide text-steel sm:text-base" data-id="element-53" data-mp="39uhryxt4hxwz">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-2xs font-bold uppercase tracking-wide text-tech sm:text-sm" data-id="element-54" data-mp="3itd1ojvdlq51">
            Identify • Visualize • Measure • Interpret • Evaluate • Document
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-55" data-mp="1en5sklj48ct1">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-56" data-mp="1shouywz27gbc">
            🔥 GET THE COMPLETE SYSTEM TODAY — <span className="text-tech" data-id="element-57" data-mp="22ekwgiqjj26e">$27 USD</span>
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-58" data-mp="22d04n0vm1xc8">🔍 GET {PRODUCT}</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-59" data-mp="1xeousq5bfmu0" />
        </div>
      </div>
    </section>;
}